import { envBasics } from 'src/environments/trackline/basics';
import { Environment } from '../../app/environment';

export const environment: Environment = {
    ...envBasics,
    apiEndpoint: 'https://planning-acc.trackline.nl/api/',
    disableAfas: true,
    feEndpoint: 'https://planning-acc.trackline.nl/',
    orderDirect: true,
    production: true,
    test: true,
    titleAppend: ' - ACCEPTANCE - Track Line B.V.',
    wsEndpoint: 'wss://planning-acc.trackline.nl/websocket/',
};
